module.exports = __webpack_public_path__ + "static/img/title-banner1-type3.226a161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/7/title-banner1-type3.png
// module id = Djhl
// module chunks = 1